import { Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientCommon } from "@obg/common.config";
import { ConfigService } from "@obg/ngx.global";

@Injectable({
	providedIn: "root",
})
export class ContentConfigService {
	constructor(private service: ConfigService<ObgConfigFeAdaptiveClientCommon>) {}

	isAnchorsMenuEnabled(): boolean {
		return this.service.get((x) => x.common.content.anchorsMenuEnabled, false);
	}

	isTableFormattingEnabled(): boolean {
		return this.service.get((x) => x.common.content.contentTableStylingEnabled, false);
	}
}
